module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-night2.4375842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-night2.png
// module id = +fNF
// module chunks = 0